export default {"src":"/_next/static/media/great.e8da6122.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};